import gql from 'graphql-tag';

export default gql`
  mutation updateHEAccount($input: updateHEAccountInput!) {
    updateHEAccount(input: $input){
      heAccount {
        id
        primaryUser{
          id
        }
        userList{
          id
          active
          lockStatus
        }
        activeMatchNotificationsAdditionalEmails
        activeMatchNotificationsContacts{
          id
        }
      }
    }
  }
`;
